import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Searchbox from "../controls/Searchbox";
import CustomTabs from "../controls/Tabs";
import TabContainer from "../controls/TabContainer";
import Cancel from "material-ui-icons/Cancel";
import moment from "moment";
import MdClose from "material-ui-icons/Close";
import {
  Col,
  Row,
  Modal,
ModalBody,
ModalFooter,
ModalHeader,
Label,
Input,
Table,
FormGroup,
Popover, PopoverHeader, PopoverBody,
Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
Spinner


} from 'reactstrap';

const styles = theme => ({
  root: {
    padding: 10
  },
  tabHolder: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tab: {
    boxShadow: "none"
  },
  tabItem: {
    fontSize: "12px"
  },
  indicator: {
    backgroundColor: "#3f51b5"
  },
  wrapper: {
    marginTop: 20,
    position: "relative"
  }
});

class CloseCash extends Component {
  state = {
    
    modal: false,
    value: 0
  };

  componentDidMount() {
    if (this.props.history.location.pathname === "/expense") {
      this.setState({ value: 0 });
    } else {
      this.setState({ value: 1 });
    }
  }

  handleChange = (event, value) => {
    if (value === 0) {
      this.props.history.push("/expense");
    } else {
      this.props.history.push("/expensetypes");
    }
    this.setState({ value });
  };

  toggle = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
      });
    }

    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  render() {
    const { classes } = this.props;
    const { value, showForm, clearSearch } = this.state;
    var date = moment().format("DD MMM YYYY")

    return (
      
      <div className={classes.wrapper}>
        <div>
          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>

        <div className="closeCashGTotal">
          <span style={{padding:"5px"}}>Grand Total: RM109,100.00</span>
          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.toggle()}>
              Close Cashier
          </Button>
        </div>

        <div className={classes.tabHolder}>
        <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>Payment Mode</th>
              <th>Date</th>
              <th>Amount (RM)</th>
              <th>Cashier ID</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td>Cash</td>
              <td>{date}</td>
              <td>50,000.00</td>
              <td>3948</td>
            </tr>
            <tr className="customtr">
              <td>Credit Card</td>
              <td>{date}</td>
              <td>20,000.00</td>
              <td>3948</td>
            </tr>
            <tr className="customtr">
              <td>eWallet</td>
              <td>{date}</td>
              <td>4,000.00</td>
              <td>3948</td>
            </tr>
            <tr className="customtr">
              <td>Cheque</td>
              <td>{date}</td>
              <td>30,000.00</td>
              <td>3948</td>
            </tr>
            <tr className="customtr">
              <td>Others</td>
              <td>{date}</td>
              <td>5,000.00</td>
              <td>3948</td>
            </tr>
          </table>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}>
          <ModalHeader toggle={this.toggle()}>Summary of Cashier ID 3948</ModalHeader>
          <ModalBody>
          <table className="customtable closecashiertable">
            <tr className="customtr">
              <th className="customtdleft">Payment Mode</th>
              <th className="customtdright">Amount (RM)</th>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">Opening Balance</td>
              <td className="customtdright">100.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">Cash</td>
              <td className="customtdright">50,000.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">Credit Card</td>
              <td className="customtdright">20,000.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">eWallet</td>
              <td className="customtdright">4,000.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">Cheque</td>
              <td className="customtdright">30,000.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft">Others</td>
              <td className="customtdright">5,000.00</td>
            </tr>
            <tr className="customtr">
              <td className="customtdleft"><b>Total</b></td>
              <td className="customtdright"><b>109,100.00</b></td>
            </tr>
          </table>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle()}>
              Close and Post to GL
            </Button>
          </ModalFooter>
        </Modal>


      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(CloseCash));



// WEBPACK FOOTER //
// ./src/components/misc/CloseCash.js